import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';
import {
  markerIcon,
  popup,
} from '@/helpers/map';

let L;

class MapController extends Controller {
  connect() {
    MapController.loadLeaflet()
      .then((module) => {
        L = module.default;

        this.map = this.createMap();
        this.markers = [];
        this.mapMarkers = [];
        this.openMarker = null;
      })
      .then(() => this.filter());
  }

  onFilterClick(e) {
    e.preventDefault();

    this.filter();
  }

  filter() {
    const filters = toArray(this.filterTarget.querySelectorAll('select, input'));
    const data = {};

    filters.forEach((filter) => {
      data[filter.name] = filter.value;
    });

    $.ajax({
      url: this.filterTarget.action,
      method: 'POST',
      data,
      success: (res) => {
        this.updateMap(res.map.meta);
        this.addMarkers(res.map.users);
      },
      error: () => {
        // console.error(err);
      },
    });
  }

  addMarkers(users) {
    if (this.markers.length) {
      this.markers.forEach((marker) => {
        this.map.removeLayer(marker);
      });
    }

    users.forEach((user) => {
      const { latitude, longitude } = user;

      if (latitude === '' || longitude === '') return;

      const marker = L.marker([parseFloat(latitude), parseFloat(longitude)], {
        icon: markerIcon,
      }).addTo(this.map);

      marker.on('click', () => {
        this.closePopup();

        const popupElement = popup(user);

        this.wrapperTarget.appendChild(popupElement);

        this.openMarker = marker;
      });

      this.markers.push(marker);
    });
  }

  closePopup() {
    if (this.hasPopupTarget) {
      this.openMarker = null;
      this.popupTarget.parentNode.removeChild(this.popupTarget);
    }
  }

  createMap() {
    const map = L.map(this.mapTarget, {
      center: this.data.get('center').split(','),
      zoom: this.data.get('zoom'),
      zoomControl: false,
    });

    L.gridLayer.googleMutant({
      type: 'roadmap',
    }).addTo(map);

    return map;
  }

  updateMap(meta) {
    this.map.flyTo({
      lat: meta.latitude,
      lng: meta.longitude,
    });
  }

  openMap() {
    this.wrapperTarget.classList.add('is-open');
  }

  closeMap() {
    this.wrapperTarget.classList.remove('is-open');
  }

  static loadLeaflet() {
    return new Promise((resolve, reject) => {
      import(/* webpackChunkName: "leaflet" */ '../vendor/leaflet')
        .then(resolve)
        .catch(reject);
    });
  }
}

MapController.targets = [
  'map',
  'filter',
  'popup',
  'wrapper',
];

export default MapController;
